import { createFileRoute } from '@tanstack/react-router';
import { SignInPage } from '../../features/identity';

export const Route = createFileRoute('/_public/sign-in/')({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } =>
    typeof search.redirect === 'string' ? { redirect: search.redirect } : {},
  component: SignInPage,
});
